import { createAsyncThunk } from '@reduxjs/toolkit';
import { getMakes, createMake, updateMake, deleteMake } from '../../lib/vehicleMakes';

export const fetchMakes = createAsyncThunk('makes/getMakes', async () => {
  const data = await getMakes();
  return data;
});

export const addMake = createAsyncThunk(
  'makes/addMake',
  async (body, { rejectWithValue }) => {
    try {
      const data = await createMake(body);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const editMake = createAsyncThunk(
  'makes/editMake',
  async ({ makeId, body }) => {
    const data = await updateMake(makeId, body);
    return data;
  }
);

export const removeMake = createAsyncThunk('make/removeMake', async (makeId) => {
  await deleteMake(makeId);
  return makeId;
});
